var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7128_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 12.25V13.5C11.3125 14.8785 10.191 16 8.8125 16H2.53125C1.15271 16 0.03125 14.8785 0.03125 13.5V2.5C0.03125 1.12146 1.15271 0 2.53125 0H8.8125C10.191 0 11.3125 1.12146 11.3125 2.5V3.75C11.3125 4.09521 11.0327 4.375 10.6875 4.375C10.3423 4.375 10.0625 4.09521 10.0625 3.75V2.5C10.0625 1.81079 9.50171 1.25 8.8125 1.25H2.53125C1.84204 1.25 1.28125 1.81079 1.28125 2.5V13.5C1.28125 14.1892 1.84204 14.75 2.53125 14.75H8.8125C9.50171 14.75 10.0625 14.1892 10.0625 13.5V12.25C10.0625 11.9048 10.3423 11.625 10.6875 11.625C11.0327 11.625 11.3125 11.9048 11.3125 12.25ZM15.5736 6.92639L14.1741 5.52686C13.9299 5.28271 13.5342 5.28271 13.2902 5.52686C13.046 5.77087 13.046 6.16663 13.2902 6.41064L14.2856 7.40625H6.78125C6.43604 7.40625 6.15625 7.68604 6.15625 8.03125C6.15625 8.37646 6.43604 8.65625 6.78125 8.65625H14.2856L13.2902 9.65186C13.046 9.89587 13.046 10.2916 13.2902 10.5356C13.4122 10.6577 13.5721 10.7188 13.7321 10.7188C13.8921 10.7188 14.052 10.6577 14.1741 10.5356L15.5736 9.13611C16.1829 8.52686 16.1829 7.53564 15.5736 6.92639Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7128_161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b680684c084366cdffb7d8391a3eee53.svg";
export { ForwardRef as ReactComponent };